import { isDevMode } from '@angular/core';

/**
 * Silences `console.log` in production builds so that no application data
 * (tokens, API payloads, user/tenant details) is exposed in the browser
 * DevTools console. `console.error` and `console.warn` stay active.
 * `ng serve` keeps logging.
 *
 * Must stay the first import in `main.ts` so it runs before any other module.
 */
if (!isDevMode()) {
    console.log = (): void => {};
}
